import { findNotSellersByCompany } from '../../_services/user.service';
import { getCompany } from '../../_utils/storage_handler';

export const findAllUsersEvent = async () => {
    let res = await findNotSellersByCompany(getCompany());
    if(! res.ok){
        throw new Error(res.error);
    }
    return res;
}